import $ from 'jquery';
import 'jquery-mask-plugin';

$('.format-phone').mask('(999) 999-9999');
